import React, { useState, useEffect } from "react";
import { ButtonAlternativeStyled, ButtonPrimaryStyled, ButtonsContainer } from "./buttons.styled";
import { getUserEnrollementPage} from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { Skeleton } from "antd";
import { StrapiError } from "../../../pages/StrapiError";
interface IBackNextButtonProps {
  goBack: () => void;
  goToNext: () => void;
  omitNext: boolean;
  omitBack: boolean;
}
const BackNextButtons = ({ goBack, goToNext, omitBack, omitNext }: IBackNextButtonProps) => {
  const { locale } = useLocale();
  const [userEnrollementPage, setUserEnrollementPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);
  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setUserEnrollementPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    getUserEnrollementPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setUserEnrollementPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setUserEnrollementPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setUserEnrollementPage(null);
      }}
    />;
  }
  return (
    <ButtonsContainer>
      {!omitBack && (
        <ButtonAlternativeStyled type="primary" size="large" onClick={goBack} ghost>
          {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 80 }} /> : (userEnrollementPage?.back_button || "Atrás")}
        </ButtonAlternativeStyled>
      )}
      {!omitNext && (
        <ButtonPrimaryStyled type="primary" size="large" onClick={goToNext}>
          {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (userEnrollementPage?.next_button || "Siguiente")}
        </ButtonPrimaryStyled>
      )}
    </ButtonsContainer>
  );
};

export default BackNextButtons;
